export const COMPANY_NAME = 'CÔNG TY CỔ PHẦN TTMI';
